import React from 'react';

const ServiceAsbuilt = () => {
  return (
    <section className="service-asbuilt-section">
      <div className="service-asbuilt-container">
        <h2 className="asbuilt-title">
          <span className="text-primary">What Are As-Built</span> Modeling Services?
        </h2>
        
        <div className="asbuilt-content">
          <p className="asbuilt-text">
            As-built modeling services produce a virtual three-dimensional replica of the real world that represents the current state of a structure or building. Professionals utilize the latest technology such as 3D laser scanning and photogrammetry to obtain accurate measurements and data of the site. This collected data will then be used to generate an accurate, detailed design called Building Information Model (BIM).
          </p>
          
          <p className="asbuilt-text">
            The BIM acts as a "Digital Twin" or digital counterpart of the actual space, containing all architectural elements, structural elements, and MEP (Mechanical, Electrical and Plumbing) elements of that area. As-built models are critical to renovation projects, facilities management, and historical preservation efforts, as they provide an accurate and reliable foundation from which future design and construction efforts can be based on.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ServiceAsbuilt;
